// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"4065":"f1139ec30708e44e1094","4254":"96661b9f421b07ce7189"}[chunkId] + "";
};